module.exports = __webpack_public_path__ + "img/LogoLarge.2ecbd098.svg";